<template>
  <div id="print">

    <div class="book m-auto">

      <div
        v-for="(data, idx) in Math.ceil(goodstransfer.orders.length/maxOrderLists)"
        :key="idx"
        class="page">
        <div class="subpage">
          <div
            class="top-header"
            style="padding: 0 0 30px 0;">
            <div
              v-if="idx == 0"
              class="company-info">
              <img
                v-if="shopInfo.logo.thumbnail"
                :src="shopInfo.logo.thumbnail">
              <div class="name">
                <strong class="text-black">{{ shopInfo.shop_name }}</strong>
                <p>{{ shopInfo.info.location.address }}</p>
              </div>
            </div>
            <div class="document-type">
              <h2 class="text-black">{{ $t('documents.gt') }}</h2>
              <p>{{ goodstransfer.gt_code }}</p>
            </div>
          </div>
          <div
            v-if="idx == 0"
            class="content">
            <div class="left">
              <div class="section">
                <p class="label">{{ $t('apps.inventory.message.transferdate') }}</p>
                <p class="detail">{{ getDateTime(goodstransfer.scheduled_at) }}</p>
              </div>
              <div class="section">
                <p class="label">{{ $t('apps.inventory.message.postingattransferredorders') }}</p>
                <p class="detail">
                  {{ goodstransfer.posting_at ? getDateTime(goodstransfer.posting_at) : '-' }}
                </p>
              </div>
            </div>
          </div>
          <div class="order">
            <table>
              <thead>
                <tr>
                  <td width="10px"><b>#</b></td>
                  <td width="40%"><b>{{ $t('message.description') }}</b></td>
                  <td class="text-right"><b>{{ $t('message.quantity') }}</b></td>
                  <td class="text-right"><b>{{ $t('status.gt.done') }}</b></td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="({ item, quantity, done }, idx_) in groupOrders[idx].orders"
                  :key="idx_">
                  <td width="10px"><b>{{ (maxOrderLists*idx)+(idx_+1) }}</b></td>
                  <td width="40%">{{ item }}</td>
                  <td class="text-right">{{ getNumber(quantity) }}</td>
                  <td class="text-right">{{ getNumber(done) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            v-if="Math.ceil(goodstransfer.orders.length/maxOrderLists) > 0 && idx !== (Math.ceil(goodstransfer.orders.length/maxOrderLists)-1)"
            class="next-page">
            {{ $t('message.havenextpage') }}
          </div>

          <div
            v-if="idx >= (Math.ceil(goodstransfer.orders.length/maxOrderLists)-1)"
            class="footer"
            style="display: flex;justify-content: space-between;">

            <div
              class="note"
              style="width: auto;max-width: 360px;">
              <div
                v-if="goodstransfer.note"
                class="section">
                <p>{{ $t('message.note') }}</p>
                <p style="white-space: pre-wrap;">{{ goodstransfer.note }}</p>
              </div>
            </div>

            <div
              class="total"
              style="width: auto;margin: 0;flex: 1;max-width: 400px;">

              <div
                class="section"
                style="display: flex;flex-direction: column;">

                <div
                  class="section"
                  style="display: flex;justify-content: space-between;margin: 0 0 10px 0;">
                  <div
                    style="width: auto;max-width: none;flex: none;">
                    {{ $t('apps.inventory.message.pickfrom') }}
                  </div>
                  <div
                    style="width: auto;max-width: none;flex: 1;text-align: right;">
                    <span class="text-underline-border">
                      {{ getWhLocationName(goodstransfer.stockout.warehouse_id, goodstransfer.stockout.bin_location_id) }}
                    </span>
                  </div>
                </div>

                <div
                  class="section"
                  style="display: flex;justify-content: space-between;margin: 0 0 10px 0;">
                  <div
                    style="width: auto;max-width: none;flex: none;">
                    {{ $t('apps.inventory.message.shipto') }}
                  </div>
                  <div
                    style="width: auto;max-width: none;flex: 1;text-align: right;">
                    <span class="text-underline-border">
                      {{ getWhLocationName(goodstransfer.stockin.warehouse_id, goodstransfer.stockin.bin_location_id) }}
                    </span>
                  </div>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  props: {
    goodstransfer: {
      type: Object,
    },
  },
  data () {
    return {
      maxOrderLists: 15,
    }
  },
  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
      getPartnerContact: 'getPartnerContact',
      getWarehouseInfo: 'getWarehouseInfo',
      getWhLocationName: 'getWhLocationName',
    }),
    groupOrders () {
      var results = []
      var currentIdx = 0

      for (let i = 0; i < Math.ceil(this.goodstransfer.orders.length / this.maxOrderLists); i++) {
        var page = i + 1
        results.push({
          'page': page,
          'orders': [],
        })
      }

      for (let i = 0; i < this.goodstransfer.orders.length; i++) {
        let order = this.goodstransfer.orders[i]

        if (i % (this.maxOrderLists) == 0 && i !== 0) {
          currentIdx++
        }

        results[currentIdx].orders.push(order)
      }

      return results
    },
    warehouseNameForm () {
      return this.getWarehouseInfo(this.goodstransfer.stockout.warehouse_id)
    },
    warehouseNameTo () {
      return this.getWarehouseInfo(this.goodstransfer.stockin.warehouse_id)
    },
  },
}
</script>

<style scoped>
  @page {
      size: A4;
      margin: 0;
  }

  @media print {
      #print .page {
          margin: 0;
          border: initial;
          border-radius: initial;
          width: initial;
          min-height: initial;
          box-shadow: initial;
          background: initial;
          page-break-after: always;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/goodstransfer/include/PrintGt.vue